import React, { useEffect, useState } from "react";
import { TbBrandTwilio } from "react-icons/tb"; // Importing the Twilio brand icon from react-icons
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiClient } from "../../../../api";
import { baseUrl } from "../../../../Environments/environment";
import { ThreeDot } from "react-loading-indicators";
import TwiloBilling from "./TwiloBilling";

const TwilioSetup = () => {
  const { selectedPropertyId } = useProperty();
  const [propertyName, setPropertyName] = useState("");
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [twilioId, setTwilioId] = useState("");
  const [status, setStatus] = useState("active");
  const [messageCount,setMessageCount] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    if (!selectedPropertyId) {
      navigate("/propertyhome");
      toast.warn("Select the property first!!");
    }
  }, [selectedPropertyId, navigate]);
  useEffect(() => {
    if (selectedPropertyId) {
      fetchPropertyData(selectedPropertyId);
    }
  }, [selectedPropertyId]);
  const fetchPropertyData = async (propertyId) => {
    setLoading(true);
    try {
      const response = await apiClient.get(`${baseUrl}/property/${propertyId}`);
      const twilloAccount = await apiClient.get(
        `${baseUrl}/twilioAccount/${propertyId}`
      );
      console.log("Twilo Account :- ", twilloAccount);
      if (response.status === 200) {
        const { property } = response.data.result.property;
        setPropertyName(property.name);
      }
      if (twilloAccount.status === 200) {
        setCountryCode(twilloAccount.data.result.countryCode);
        setPhoneNumber(twilloAccount.data.result.phoneNumber);
        setTwilioId(twilloAccount.data.result.twilioId);
        setMessageCount(twilloAccount.data.result.messageCount);
        if (twilloAccount.data.result.status) {
          setStatus(twilloAccount.data.result.status);
        }
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error fetching property data.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
    <div className="bg-gray-100 p-4 sm:p-6 lg:p-8 xl:p-12 flex justify-center">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 sm:p-6 w-full max-w-4xl">
        {loading ? (
          <div className="flex flex-row justify-center items-center py-8">
            <ThreeDot
              variant="brick-stack"
              color="#4f46e5"
              size="medium"
              text=""
              textColor=""
            />
          </div>
        ) : (
          <>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 mb-4 sm:mb-6">
              {/* Icon Section */}
              <div className="flex-shrink-0 sm:mr-8">
                <TbBrandTwilio className="text-indigo-600 w-16 h-16 sm:w-24 sm:h-24" />
              </div>
              {/* Content Section */}
              <div className="w-full">
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                  Twilio Setup
                </h2>
                <p className="text-gray-600 text-sm mb-4 sm:mb-6">
                  Set up your Twilio account to start sending SMS messages through
                  our platform. This setup will allow you to manage communication
                  directly from your dashboard.
                </p>
              </div>
            </div>
            {/* Twilio Details Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6 text-gray-800">
              <div>
                <h3 className="font-semibold text-sm sm:text-base">Property Name:</h3>
                <p className="text-gray-600 text-sm sm:text-base">{propertyName}</p>
              </div>
              <div>
                <h3 className="font-semibold text-sm sm:text-base">Twilio ID:</h3>
                <p className="text-gray-600 text-sm sm:text-base break-all">{twilioId}</p>
              </div>
              <div>
                <h3 className="font-semibold text-sm sm:text-base">Account Status:</h3>
                <p
                  className={`font-medium text-sm sm:text-base ${
                    status === "active" ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {status
                    ? status.charAt(0).toUpperCase() + status.slice(1)
                    : "Inactive"}
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-sm sm:text-base">Phone Number:</h3>
                <p className="text-gray-600 text-sm sm:text-base">{`${countryCode} ${phoneNumber}`}</p>
              </div>
              <div>
                <h3 className="font-semibold text-sm sm:text-base">Messages Sent:</h3>
                <p className="text-gray-600 text-sm sm:text-base">{messageCount}</p>
              </div>
              <div>
                <h3 className="font-semibold text-sm sm:text-base">Monthly Limit:</h3>
                <p className="text-gray-600 text-sm sm:text-base">1,000 messages</p>
              </div>
            </div>

            <button
              className="bg-indigo-600 hover:bg-indigo-500 text-white font-medium px-4 py-2 text-sm sm:text-base rounded-md focus:outline-none transition-all w-full sm:w-auto"
              onClick={() => console.log("Start Twilio Setup")}
            >
              Configure Twilio
            </button>
          </>
        )}
      </div>
    </div>
    {/* <TwiloBilling /> */}
    </>
  );
};

export default TwilioSetup;
